<template>
  <div
    style=" width: 100%; margin-bottom: 70px;     overflow: auto;
    max-height: calc(100% - 64px);     width: inherit;
"
    v-chat-scroll="{always: false, smooth: true}"
    @v-chat-scroll-top-reached="loadMore()"
  >
    <div
      v-for="msg in messagesReverse"
      :class="{ 'd-flex flex-row-reverse': msg.sender_id == userId }"
      :key="msg.id"
    >
      <v-chip
        v-if="msg.attachments&&msg.attachments.length > 0"
        :color="msg.sender_id== userId ||msg.recipient_id!= userId? 'primary' : ''"
        outlined
        style="height:auto;white-space: normal;"
        class="pa-4 mb-2"
      >
        <div style="max-width:300px;max-height:300px">
          <expandableImage
            v-if="(msg.attachments[0]['content-type'] 
              && 
              msg.attachments[0]['content-type'].includes('image')
            )
            ||(msg.extension &&
           
            (msg.extension.attachments[0]['content-type'] 
              && 
              msg.extension.attachments[0]['content-type'].includes('image')
            
            ||
            msg.extension.attachments[0]['type'].includes('image')))"
            :src="getMessageAttachment(msg)"
            style="max-width:100%;max-height:100%"
          />
        </div>

        <video
          controls
          v-if="(msg.attachments[0]['content-type'] && msg.attachments[0]['content-type'].includes('video'))||msg.attachments[0]['type'].includes('video')"
          :src="getMessageAttachment(msg)"
          width="300px"
          @click="this.play()"
        />
        <audio
          controls
          v-if="(msg.attachments[0]['content-type'] &&msg.attachments[0]['content-type'].includes('audio'))||msg.attachments[0]['type'].includes('audio')"
          :src="getMessageAttachment(msg)"
          width="300px"
          @click="this.play()"
        />
        <!-- <sub class="ml-2" style="font-size: 0.5rem;">{{ msg.created_at }}</sub> -->
        <sub class="ml-2" style="font-size: 0.5rem;">
          <timeago
            :datetime="msg.created_at || Date(msg.extension.date_sent)"
            v-if="log(msg.created_at || msg.extension.date_sent)"
            :auto-update="60"
          ></timeago>
        </sub>
      </v-chip>
      <v-chip
        v-else
        :color="msg.sender_id== userId? 'primary' : ''"
        dark
        style="height:auto;white-space: normal;"
        class="pa-4 mb-2"
      >
        {{ msg.message||msg.body }}
        <!-- <sub class="ml-2" style="font-size: 0.5rem;">{{ msg.created_at }}</sub> -->
        <sub class="ml-2" style="font-size: 0.5rem;">
          <timeago
            :datetime="msg.created_at || Date(msg.extension.date_sent)"
            v-if="log(msg.created_at || msg.extension.date_sent)"
            :auto-update="60"
          ></timeago>
        </sub>
      </v-chip>
    </div>
  </div>
</template>

<script>
import expandableImage from "@/components/expandableImage";

export default {
  methods: {
    onMessagePush() {
      this.$emit("onMessageWasSent", this.messageForm);
      this.messages.push(this.messageForm);
      this.scrollToEnd();
    },
    loadMore() {
      this.$emit("loadMoreChats");
      console.log("load more");
    },
    updateChat() {
      this.updateList = this.updateList + 1;
    },
    log(message) {
      console.log(message);
      return true;
    },
    getMessageAttachment(message) {
      if (
        (message.attachments && message.attachments.length > 0) ||
        (message.extension.attachments &&
          message.extension.attachments.length > 0)
      ) {
        var fileUID =
          message.attachments[0].id || message.extension.attachments[0].id;
        var fileUrl = this.QB.content.privateUrl(fileUID);
      }
      document.body.style.overflow = "hidden";
      return fileUrl;
    }
  },
  components: { expandableImage: expandableImage },
  props: ["messages", "userId", "QB"],
  computed: {
    messagesReverse() {
      let messages = this.messages.slice();
      // messages = messages.filter(message => message.attachments.length > 0);
      // messages.filter(message => message.message);
      //this.updateChat();
      return messages.reverse();
    }
  },

  data: () => ({
    activeChat: 1,
    updateList: 0,
    messageForm: {
      content: "",
      me: true,
      created_at: "11:11am"
    }
  })
};
</script>

<style>
</style>